module.exports = {"411523001":"金兰山街道","411523100":"新集镇","411523101":"沙窝镇","411523103":"吴陈河镇","411523104":"苏河镇","411523105":"八里畈镇","411523201":"周河乡","411523202":"陡山河乡","411523203":"浒湾乡","411523204":"千斤乡","411523205":"卡房乡","411523206":"郭家河乡","411523207":"陈店乡","411523208":"箭厂河乡","411523209":"泗店乡","411523210":"田铺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411523.json
// module id = 1668
// module chunks = 0